import { useState } from "react";
import { Loader2, RotateCcw, LogOut } from "lucide-react";
import { toast } from "sonner";
import { http, formatError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { BrynLogo } from "@/components/BrynLogo";

export function RestoreAccount() {
  const { user, setUser, logout } = useAuth();
  const [busy, setBusy] = useState(false);
  const when = new Date(user.deletion.purge_at).toLocaleDateString(undefined, { day: "numeric", month: "long", year: "numeric" });
  const restore = async () => {
    setBusy(true);
    try {
      const { data } = await http.post("/account/restore");
      setUser(data);
      toast.success(data.renewal_resumed ? "Welcome back. Your account and plan renewal are restored." : "Welcome back. Your account is restored.");
    } catch (e) { toast.error(formatError(e)); setBusy(false); }
  };
  return (
    <div className="min-h-[100dvh] flex items-center justify-center px-4" data-testid="restore-account-screen">
      <div className="soft-card max-w-md w-full p-6 sm:p-8 space-y-5">
        <BrynLogo markClass="h-8 w-8" />
        <h1 className="font-display text-2xl font-semibold tracking-tight">Your account is set to be deleted</h1>
        <p className="text-sm text-neutral-400" data-testid="restore-account-date">Everything in {user.email} will be deleted for good on {when}. Restore it now to keep your chats, artifacts and progress.</p>
        <p className="text-xs text-neutral-500">If your plan's renewal was stopped when you asked to delete, restoring turns it back on.</p>
        <div className="flex flex-wrap gap-2">
          <button onClick={restore} disabled={busy} className="h-11 px-5 rounded-full bg-sky-400 text-white text-sm font-medium hover:bg-sky-500 disabled:opacity-50 inline-flex items-center gap-2" data-testid="restore-account-btn">
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <RotateCcw className="h-4 w-4" />}Restore my account
          </button>
          <button onClick={logout} className="h-11 px-5 rounded-full border border-white/15 text-sm hover:bg-white/5 inline-flex items-center gap-2" data-testid="restore-account-signout-btn"><LogOut className="h-4 w-4" />Sign out</button>
        </div>
      </div>
    </div>
  );
}
